/** Common dial codes for country selector (E.164 prefix without +). */
export const COUNTRY_OPTIONS = [
  { code: 'US', label: 'United States', dial: '1' },
  { code: 'CA', label: 'Canada', dial: '1' },
  { code: 'GB', label: 'United Kingdom', dial: '44' },
  { code: 'IN', label: 'India', dial: '91' },
  { code: 'AU', label: 'Australia', dial: '61' },
  { code: 'MX', label: 'Mexico', dial: '52' },
  { code: 'FR', label: 'France', dial: '33' },
  { code: 'DE', label: 'Germany', dial: '49' },
];

/**
 * Build E.164 phone string from dial code and national digits.
 * @param {string} dialCode - e.g. "1", "44"
 * @param {string} nationalNumber - digits only
 */
export function toE164(dialCode, nationalNumber) {
  const digits = String(nationalNumber || '').replace(/\D/g, '');
  const dial = String(dialCode || '').replace(/\D/g, '');
  if (!digits || !dial) return '';
  return `+${dial}${digits}`;
}

export function isValidE164(phone) {
  return /^\+[1-9]\d{6,14}$/.test(phone);
}

export function maskPhone(e164) {
  if (!e164 || e164.length < 6) return e164;
  return `${e164.slice(0, 3)}***${e164.slice(-4)}`;
}
